import clsx from 'clsx';
import React from 'react';

import IconAppQRCode from '@components/Images/IconAppQRCode';
import LazyImgixImage from '@components/LazyImgixImage';
import { SubscribeSource } from '@utils/backend-api/userOnboarding';
import { getImgixSrc } from '@utils/images';

import ProgressBar from './ProgressBar';
import { OnboardingSteps, stepImage } from './interface';

interface StepHeroProps {
  step: OnboardingSteps;
  isProSubscriber: boolean;
  subscribeSource?: SubscribeSource;
}

const StepHero = ({ step, isProSubscriber, subscribeSource }: StepHeroProps) => {
  const imageUrl = getImgixSrc({
    path: stepImage[step].img,
    isEnvDependent: false,
  });

  const currentStep = stepImage[step];

  return (
    <>
      {step === OnboardingSteps.FINAL ? (
        <div className="flex h-full w-full flex-col justify-center gap-y-64 bg-black px-80">
          <div>
            {currentStep.title}
            <p className="m-0 font-suisse-screen text-body-lg text-white">{currentStep.subtitle}</p>
          </div>
          <div className="flex gap-24">
            <IconAppQRCode
              className={clsx('border border-solid', {
                'border-primary-magenta': !isProSubscriber,
                'border-pro-gold': isProSubscriber,
              })}
            />
            <div className="flex flex-col justify-center gap-4">
              <LazyImgixImage
                src={getImgixSrc({
                  path: '/onboarding/app_icon.png',
                  isEnvDependent: false,
                })}
                alt="App Logo"
                className="w-[60px]"
              />
              <p className="m-0 mt-8 font-suisse-screen text-overline-lg text-white ">
                Scan to download the app
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="flex h-full w-full flex-col justify-around bg-cover bg-center bg-no-repeat px-40"
          style={{ backgroundImage: `url(${imageUrl})` }}
        >
          <div>
            {currentStep.title}
            <p className="text-sm text-white">{currentStep.subtitle}</p>
          </div>
          <ProgressBar
            step={step}
            isProSubscriber={isProSubscriber}
            subscribeSource={subscribeSource}
          />
        </div>
      )}
    </>
  );
};

export default StepHero;
